module.exports = __webpack_public_path__ + "img/marca_smart.a9cb98ce.jpg";